import { useQuery } from "hooks/useQuery";
import { useState } from "react";
import { ProgramsService } from "services/programs";
import IconButton from "components/blocks/IconButton";
import { useNavigate } from "react-router-dom";
import useSystemDateTheme from "hooks/useSystemDateTheme";
import LoadingOverlay from "components/blocks/LoadingOverlay";
import { useTranslation } from "react-i18next";
import { LookupService } from "services/lookupService";
import { OperatorFilter } from "services/shared-models/sharedEnums";
import { DataGridRequest } from "services/shared-models/sharedTypes";
import MultiSelectDropdown from "components/blocks/MultiSelectDropdown";
import { useCookieContext } from "contexts";
import ProgramCard from "./ProgramCard";

const ProgramsTaps = () => {
  const { t} = useTranslation("WelcomePage");
  const { isAr } = useCookieContext();

  const [activeProgramTypeId, setActiveProgramTypeId] = useState(-1);
  const [activeAudiencesType, setActiveAudiencesType] = useState<number[]>([]);

  const { data, loading } = useQuery({
    queryFn: async () => {
      const filter: DataGridRequest["filter"] =
        activeProgramTypeId === -1
          ? []
          : [
              {
                field: "ClassificationProgram.ProgramTypeId",
                value: activeProgramTypeId,
                operator: OperatorFilter.equal,
              },
            ];

      if (activeAudiencesType.length) {
        filter.push({ field: "audienceTypes", value: activeAudiencesType, operator: OperatorFilter.contains });
      }

      return await ProgramsService.getAllPublicPrograms({
        pageIndex: 1,
        pageSize: 10,
        filter: filter,
      });
    },
    triggers: [activeProgramTypeId, isAr, ...activeAudiencesType],
  });

  const { data: audienceTypes, loading: audienceTypesLoading } = useQuery({
    queryFn: async () => {
      return await LookupService.getAllAudienceTypes();
    },
    triggers: [isAr],
  });

  const { data: programsTypes, loading: programsTypesLoading } = useQuery({
    queryFn: async () => {
      return await LookupService.getAllProgramTypes();
    },
    triggers: [isAr],
  });

  return (
    <div>
      <div className="d-flex gap-2 flex-wrap">
        {loading && <LoadingOverlay visible={programsTypesLoading || audienceTypesLoading} />}
        {[
          {
            id: -1,
            programTypesDetail: {
              displayName: t("all"),
              locale: "En",
            },
          },
        ]
          .concat(programsTypes ?? [])
          .map((tab) => (
            <button
              key={tab.id}
              disabled={loading}
              className={`fs-14px p-10px rounded-4 btn  ${
                activeProgramTypeId === tab.id ? "btn-outline-primary active" : "border text-dark"
              }`}
              onClick={() => setActiveProgramTypeId(tab.id)}
            >
              {tab.programTypesDetail.displayName}
            </button>
          ))}

        <MultiSelectDropdown
          data={audienceTypes?.map((ele) => ({ value: ele.audienceTypeDetail.displayName, id: ele.id })) || []}
          onChange={(values) => {
            setActiveAudiencesType(values.map(Number));
          }}
        />
      </div>

      <div className="d-flex flex-wrap gap-3 mt-2 position-relative flex-row">
        {loading && <LoadingOverlay visible={loading} />}

        {data?.result.map((program) => (
          
        <ProgramCard program={program} />
            
        ))}
       
      </div>
    </div>
  );
};

export default ProgramsTaps;
